<template>
<div>
    <card v-if="isLoading">
        Loading...
    </card>
    <card v-else>
        <b-row>
            <b-col>
                <h3>Domain Detail</h3>
            </b-col>
            <b-col></b-col>
            <b-col></b-col>
            <b-col></b-col>
            <b-col>
                <h5>Is active</h5>
                <base-checkbox v-model="domain.is_active"></base-checkbox>
            </b-col>
            <b-col>
                <button class="btn btn-info" @click="saveDomain()">{{this.domain.id===null ? 'Create' : 'Save'}}</button>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <b-col>
                <base-input label="ID" placeholder="ID" :readonly="true" v-model="domain.id"></base-input>
            </b-col>
            <b-col>
                <base-input label="Brand ID" placeholder="Brand ID" type="number" v-model="domain.brand"></base-input>
            </b-col>
            <b-col>
                <base-input label="Name" placeholder="Name" v-model="domain.name"></base-input>
            </b-col>
            <b-col>
                <base-input label="Domain address" placeholder="Domain address" v-model="domain.domain_address"></base-input>
            </b-col>
            <b-col>
                <h5>Category</h5>
                <b-dropdown variant="outline-light" :text="domainCategories[domain.category]">
                    <b-dropdown-item v-for="(category,index) in domainCategories" v-bind:key="index" @click="domain.category=index">{{category}}</b-dropdown-item>
                </b-dropdown>
            </b-col>
            <b-col>
                <h5>Default method</h5>
                <b-dropdown variant="outline-light" :text="methodEnums[domain.default_method]">
                    <b-dropdown-item v-for="(method,index) in methodEnums" v-bind:key="index" @click="domain.default_method=index">{{method}}</b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <h5>Default headers</h5>
                <json-editor :data="domain.default_headers" :paramKey="'default_headers'" @change="headerChanged" />
            </b-col>
            <b-col>
                <h5>Default body</h5>
                <json-editor :data="domain.default_body" :paramKey="'default_body'" @change="bodyChanged" />
            </b-col>
       
            <b-col>
                <h5>Default body type</h5>
                <p v-if="bodyTypesLoading">Loading ...</p>
                <b-dropdown v-else variant="outline-light" :text="bodyTypes[domain.default_body_type]">
                    <b-dropdown-item v-for="(bodyType,index) in bodyTypes" v-bind:key="index" @click="domain.default_body_type=index">{{bodyType}}</b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <h5>Note Area</h5>
                <b-form-textarea rows="5" label="Domain note area" placeholder="Note area" v-model="domain.note_area"></b-form-textarea>
            </b-col>
        </b-row>
    </card>
    <card>
        <b-row>
            <h4>Domain Tags:</h4>
        </b-row>
        <b-row >
            <div v-for="(action, i) in domain.tags" :key="i">
                    <div class="badge badge-primary d-inline-flex align-items-center mr-1">
                        {{ action }}
                </div>
            </div>
        </b-row>
    </card>
</div>
</template>

<script>
import JSONEditor from '@/components/JSONEditor'
import Repository from '@/repositories/RepositoryFactory'

const DomainRepository = Repository.get('domain')
const DomainCategoryRepository = Repository.get('domain_category')

export default {
    name:'edit-domain-form',
    props:{
        domain:Object,
    },
    components:{
        [JSONEditor.name]:JSONEditor,
        
    },
    data(){
        return {
            isLoading:true,
            bodyTypesLoading:true,
            domainCategories:null,
            bodyTypes:null,
        }
    },
    created(){
        DomainCategoryRepository.get().then((response) => {
            this.domainCategories={null:'No category'}
            for(var i in response.data){
                var category = response.data[i];
                this.domainCategories[category.id]=category.name
            }
            this.isLoading=false;
        })
        DomainRepository.getBodyTypes().then((response) => {
            this.bodyTypes=response.data;
            this.bodyTypesLoading=false;
        })
    
    },
    methods:{
        updateTagList(tagList){
            this.domain.tags=tagList;
            this.$forceUpdate();
        },
        saveDomain(){
            this.$forceUpdate();
            var domainData={
                name:this.domain.name,
                domain_address:this.domain.domain_address,
                default_method:this.domain.default_method,
                default_body:this.domain.default_body,
                default_body_type:this.domain.default_body_type,
                default_headers:this.domain.default_headers,
                brand:this.domain.brand==='' ? null : this.domain.brand, // Yazılıp silinirse boş string kalıyor. Ona engel olmak için.
                category:this.domain.category,
                is_active: this.domain.is_active===undefined || this.domain.is_active ? 'True' : 'False',
                note_area: this.domain.note_area === '' ?  null : this.domain.note_area,
                tags: Array.from(this.domain.tags || [])
            }
            
            if(this.domain.id===null) // Yeni domain
                DomainRepository.post(domainData).then((response) => {
                    this.domain.id=response.data.id;
                    this.$router.push({name:'domain',params:{id:this.domain.id}});
                });
            
            else // Güncelleme
                DomainRepository.put(this.domain.id,domainData).then((response) => {
                    this.$notify({
                        message: 'Domain saved: '+this.domain.name,
                        type: 'info',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true
                    });
                })
        },
        headerChanged(changedData){
            this.domain.default_headers=changedData[0];
        },
        bodyChanged(changedData){
            this.domain.default_body=changedData[0];
        }
    }

}
</script>

<style>

</style>